// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const METADATA = {
    "tag": "sd-6.77.6-alpha-42a8a3c9",
    "splunkRumToken": "UDFaoKoARYMOKuz96Ugxyw"
};
/* tslint:enable */
